const { CrudModel } = require('./crud');

export class SectorModel extends CrudModel {
	constructor() {
		super('admin/sector', []);
	}
}

export default new SectorModel();
